import methodsMixins from './methods'
import dataMixins from './data'
export {
    methodsMixins,
    dataMixins,
    
}